export default __webpack_public_path__ + "static/media/green_subscription.45c11857.svg";